import Spinner from "./../Spinner/Spinner";
import {useEffect, useState} from "react";
import addIdToDataGridRows from "../../addIdtoDataGridRows";
import CustomPkbwlTableDataGrid from "./CustomPkbwlTableDataGrid";

export default function CustomPkbwlTable({loading, data}) {

    // console.log(data)

    const userPermissionsType = 'pkbwl';

    const [dataRows, setDataRows] = useState([])
    const [dataRowsDisplay, setDataRowsDisplay] = useState([])

    useEffect(() => {
        const dataGridRows = addIdToDataGridRows(data)
        setDataRows(dataGridRows)
        setDataRowsDisplay(dataGridRows)
    }, [data]);

    const handleFilterValues = (values) => {
        setDataRowsDisplay(values)
    }

    if (loading) {
        return <Spinner/>
    }
    if (dataRows.length < 1) {
        return <Spinner/>
    }

    return (
        <CustomPkbwlTableDataGrid
            userPermissionsType={userPermissionsType}
            dataRows={dataRows}
            handleFilterValues={handleFilterValues}
            dataRowsDisplay={dataRowsDisplay}
        />
    )

}